import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Comment20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.25 3.00006C0.25 2.3097 0.809645 1.75006 1.5 1.75006H18.5C19.1904 1.75006 19.75 2.30971 19.75 3.00006V14.5001C19.75 15.1904 19.1904 15.7501 18.5 15.7501H9.31066L6.38389 18.6768C5.59643 19.4643 4.25 18.9066 4.25 17.793V15.7501H1.5C0.809644 15.7501 0.25 15.1904 0.25 14.5001V3.00006ZM1.75 3.25006V14.2501H5.75V17.1894L8.68934 14.2501H18.25V3.25006H1.75Z'
      fill='currentColor'
    />
  </Svg>
);

Comment20.displayName = 'Comment20';
export default Comment20;
